import { Component, Input, OnInit } from '@angular/core';
import { ADPResourceService } from 'digital-core';
import { ContractContactDetails } from 'src/app/model/account/user-otp-request';

@Component({
  selector: 'app-success-step',
  templateUrl: './success-step.component.html',
  styleUrls: ['./success-step.component.scss']
})
export class SuccessStepComponent implements OnInit {

  @Input() contactInfo: ContractContactDetails = new ContractContactDetails();

  primaryEmailAddress: string = '';

  constructor(
    private resourceService: ADPResourceService
  ) { }

  ngOnInit() {

    this.primaryEmailAddress = this.contactInfo.primaryEmail;
  }

  navigateToLogin() {
    const loginRoute = this.resourceService.getPortalSetting('URL_Login').Value;
    location.replace(loginRoute);
  }

  getViewLabel(item: string) {
    const label = this.resourceService.getViewLabel(item) ?? '';
    return this.resourceService.transformContentData(label);
  }
}
